import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/packcert-web/src/environments/environment';

@Injectable()
export class EtiquetadoService {

    private _httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(private readonly _http: HttpClient) {}

    // MANTENIMIENTO ETIQUETADORES
    public getEtiquetadores(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/GetAllConFiltro', filters);
    }

    public getEtiquetador(etiquetadorId) {
        return this._http.get<any>(environment.apiEndpoint + '/Etiquetador/GetById?etiquetadorId=' + etiquetadorId);
    }

    public createEtiquetador(etiquetador) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/InsertUsuario', etiquetador);
    }

    public updateEtiquetador(etiquetador) {
        return this._http.put<any>(environment.apiEndpoint + '/Etiquetador', etiquetador);
    }

    public deleteEtiquetador(etiquetadorId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Etiquetador/?id=' + etiquetadorId);
    }

    public getPaisesEtiquetador(etiquetadorId) {
        return this._http.get<any>(environment.apiEndpoint + '/Etiquetador/GetPaisesAsignados?etiquetadorId=' + etiquetadorId);
    }

    public getReportEtiquetadoresPdf(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEtiquetadores', filters);
    }

    public getReportEtiquetadoresCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvEtiquetadores', filters);
    }

    // ETIQUETADORES - MARCA
    public getEtiquetadorMarcaPaisDenominacion(etiquetador) {
        return this._http.get<any>(environment.apiEndpoint + '/Etiquetador/GetAllEtiquetadorMarcaPaisDenominacion/?etiquetadorId='
                    + etiquetador.etiquetadorId + '&paisId=' + etiquetador.paisId + '&denominacionId=' + etiquetador.denominacionId);
    }

    public createEtiquetadorMarcaPaisDenominacion(etiquetador) {
        return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/InsertEtiquetadorMarcaPaisDenominacion', etiquetador);
    }

    public updateEtiquetadorMarcaPaisDenominacion(etiquetador) {
        return this._http.put<any>(environment.apiEndpoint + '/Etiquetador/UpdateEtiquetadorMarcaPaisDenominacion', etiquetador);
    }

    public deleteEtiquetadorMarcaPaisDenominacion(etiquetadorId, marcaId, paisId, denominacionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Etiquetador/DeleteEtiquetadorMarcaPaisDenominacion/?etiquetadorId=' +
            etiquetadorId + '&marcaId=' + marcaId + '&paisId=' + paisId + '&denominacionId=' + denominacionId);
    }

    // ETIQUETADORES - DENOMINACIONES
    public getDenominacionesEtiquetador(etiquetadorId) {
        return this._http.get<any>
                (environment.apiEndpoint + '/Etiquetador/GetAllEtiquetadorPaisDenominacion/?etiquetadorId=' + etiquetadorId);
    }

    public createDenominacionEtiquetador(denominacion) {
        return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/InsertEtiquetadorPaisDenominacion', denominacion);
    }

    public updateDenominacionEtiquetador(denominacion) {
        return this._http.put<any>(environment.apiEndpoint + '/Etiquetador/UpdateEtiquetadorPaisDenominacion', denominacion);
    }

    public deleteDenominacionEtiquetador(eitquetadorId, paisId, denominacionId) {
        return this._http.delete<any>
                (environment.apiEndpoint + '/Etiquetador/DeleteEtiquetadorPaisDenominacion/?etiquetadorId=' + eitquetadorId +
                                            '&paisId=' + paisId + '&denominacionId=' + denominacionId);
    }

    // pais
    public getPaisByEtiquetador(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Pais/GetAllConFiltro', filters);
    }

    // PAIS - DENOMINACION
    public getDenominacionesPais(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getDenominaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getAllDenominacionesEtiquetador(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getAllDenominacionesByPaisYEtiquetador(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    // ETIQUETADORES - ALMACENES
    public getAlmacenesEtiquetador(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Almacen/GetAllConFiltro', filters);
    }

    public createAlmacenEtiquetador(almacen) {
        return this._http.post<any>(environment.apiEndpoint + '/Almacen', almacen);
    }

    public updateAlmacenEtiquetador(almacen) {
        return this._http.put<any>(environment.apiEndpoint + '/Almacen', almacen);
    }

    public deleteAlmacenEtiquetador(almacenId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Almacen/?id=' + almacenId);
    }

    // PROVINCIA - MUNICIPIOS - ALMACENES - CULTIVOS
    public getProvinciasByPaisId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Provincia/GetAllConFiltro', filters);
    }

    public getMunicipiosByProvinciaId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllConFiltro', filters);
    }

    public getAlmacenesByMunicipioId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Almacen/GetAllConFiltro', filters);
    }

    public getAlmacenesByEtiquetadorId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Almacen/GetAllConFiltro', filters);
    }

    public getCultivosByMunicipioId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Cultivo/GetAllConFiltro', filters);
    }

    // MANTENIMIENTO DESIGNACIONES
    public getDesignaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Designacion/GetAllConFiltro', filters);
    }

    public getTotalesDesignaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Designacion/GetTotalesConFiltro', filters);
    }

    public getDesignacion(designacionId) {
        return this._http.get<any>(environment.apiEndpoint + '/Designacion/GetById/?designacionId=' + designacionId);
    }

    public createDesignacion(designacion) {
        return this._http.post<any>(environment.apiEndpoint + '/Designacion/', designacion);
    }

    public createDesignacionPrueba() {
        return this._http.get<any>(environment.apiEndpoint + '/Utilities/CrearDesignacionesFincaPruebas');
    }

    public updateDesignacion(designacion) {
        return this._http.put<any>(environment.apiEndpoint + '/Designacion/', designacion);
    }

    public deleteDesignacion(designacionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Designacion/?id=' + designacionId);
    }

    public getDesignacionesPdfOrExcel(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepDesignaciones', filters);
    }

    public getDesignacionesCsv(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvDesignaciones', filters);
    }

    // CAMPANYAS
    public getCampanyas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAllConFiltro', filters);
    }

    public getCampanyasMultiSelect(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAnyosCampanyaByFiltro', filters);
    }

    public getCampanyasByEtiquetadorId(etiquetadorId) {
        return this._http.get<any>(environment.apiEndpoint + '/Campanya/GetCampanyasHabilitadasByEtiquetadorId/?etiquetadorId=' + etiquetadorId);
    }

    public getCampanyasByDenominacionId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAllConFiltro', filters);
    }
    // CULTIVOS
    public getCultivosAsociados(campanyaId) {
        return this._http.get<any>(environment.apiEndpoint + '/Cultivo/GetCultivoUnionCultivoMarcaByCampanyaId/?campanyaId=' + campanyaId);
    }

    // DESIGNACIONES - ALMACENES
    public getDesignacionesAlmacen(designacionId) {
        return this._http.get<any>(environment.apiEndpoint + '/Designacion/GetAllDesignacionAlmacen/?designacionid=' + designacionId);
    }

    public createDesignacionesAlmacen(designacionAlmacen) {
        return this._http.post<any>(environment.apiEndpoint + '/Designacion/InsertDesignacionAlmacen/', designacionAlmacen);
    }

    public deleteDesignacionAlmacen(designacionAlmacen) {
        return this._http.delete<any>(environment.apiEndpoint + '/Designacion/DeleteDesignacionAlmacen/?designacionId='
            + designacionAlmacen.designacionId + '&almacenId=' + designacionAlmacen.almacenId);
    }

    public getAlmacen(almacenId) {
        return this._http.get<any>(environment.apiEndpoint + '/Almacen/GetById/?almacenId=' + almacenId);
    }

    // CONFECCIONES
    public checkEtqPaisDenominacionPermisoPallet(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/CheckEtiquetadorPaisDenominacionPermisoPallet', filters);
    }

    public getConfecciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Confeccion/GetAllConFiltro', filters);
    }

    public getConfeccion(confeccionId) {
        return this._http.get<any>(environment.apiEndpoint + '/Confeccion/GetById/?confeccionId=' + confeccionId);
    }

    public createConfeccionSimpleCaja(confeccion) {
        return this._http.post<any>(environment.apiEndpoint + '/Confeccion/InsertConfeccionCajaSimple', confeccion);
    }

    public createConfeccionSimplePallet(confeccion) {
        return this._http.post<any>(environment.apiEndpoint + '/Confeccion/InsertConfeccionPalletSimple', confeccion);
    }

    public createConfeccionCompletaCaja(confeccion) {
        return this._http.post<any>(environment.apiEndpoint + '/Confeccion', confeccion);
    }

    public createConfeccionCompletaPallet(confeccion) {
        return this._http.post<any>(environment.apiEndpoint + '/Confeccion/InsertConfeccionReutilizaConfeccionCaja', confeccion);
    }

    public createConfeccionReutilizaCajas(confeccion) {
        return this._http.post<any>(environment.apiEndpoint + '/Confeccion/InsertConfeccionReutilizaCajas', confeccion);
    }

    public updateConfeccion(confeccion) {
        return this._http.put<any>(environment.apiEndpoint + '/Confeccion', confeccion);
    }

    public deleteConfeccion(confeccionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Confeccion/?confeccionId=' + confeccionId);
    }

    public getRepConfeccionesPdfOrExcel(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepConfecciones', filters);
    }

    // REPORT CSV CONFECCIONES
    public getRepConfeccionesCsv(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvConfecciones', filters);
    }

    public duplicarConfecciones(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Confeccion/DuplicaConfeccionCambiaDenominacion', filters);
    }

    // CAJAS
    public getCajas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Caja/GetAllConFiltro', filters);
    }

    // ENVASES
    public getEnvases(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Envase/GetAllConFiltro', filters);
    }

    public getEnvase(envaseId) {
        return this._http.get<any>(environment.apiEndpoint + '/Envase/GetById/?envaseId=' + envaseId);
    }

    public createEnvase(envase) {
        return this._http.post<any>(environment.apiEndpoint + '/Envase/', envase);
    }

    public updateEnvase(envase) {
        return this._http.put<any>(environment.apiEndpoint + '/Envase/', envase);
    }

    public deleteEnvase(envaseId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Envase/?envaseId=' + envaseId);
    }

    public getEnvasesPdf(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepEnvases', filters);
    }

    public getEnvasesCsv(filters) {
      return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvEnvases', filters);
    }

    // CONSUMOS
    public getConsumos(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Consumo/GetAllConFiltro', filters);
    }

    public getConsumo(consumoId) {
        return this._http.get<any>(environment.apiEndpoint + '/Consumo/GetById/?consumoId=' + consumoId);
    }

    public getConsumosPdf(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepConsumos', filters);
    }

    public getConsumosCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvConsumos', filters);
    }

    // MARCAS
    public getMarcas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Marca/GetAllConFiltro', filters);
    }

    // REIMPRESIONES
    public getReimpresiones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Reimpresion/GetAllConFiltro', filters);
    }

    // ETIQUETADO
    public getEtiquetado(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Consumo/GetReportEtiquetado', filters);
    }

    public getRepEtiquetadoPdfOrExcel(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepConsumoEtiquetado', filters);
    }

    public getRepEtiquetadoCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvConsumoEtiquetado', filters);
    }

    // REETIQUETADO
    public getReetiquetado(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Reimpresion/GetReportReetiquetado', filters);
    }

    public getRepReetiquetadoPdf(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepConsumoReetiquetado', filters);
    }

    public getRepReetiquetadoCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvConsumoReetiquetado', filters);
    }

    // TOTALES
    public getTotales(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Consumo/GetReportConsumosTotalesResumen', filters);
    }

    public getRepTotalesPdf(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepConsumoTotales', filters);
    }

    public getRepTotalesCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvConsumoTotales', filters);
    }

    // INCIDENCIAS
    public getIncidencias(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Incidencia/GetAllConFiltro', filters);
    }

    public getIncidencia(incidenciaId) {
        return this._http.get<any>(environment.apiEndpoint + '/Incidencia/GetById/?incidenciaId=' + incidenciaId);
    }

    public createIncidencia(incidencia) {
        return this._http.post<any>(environment.apiEndpoint + '/Incidencia/', incidencia);
    }

    public updateIncidencia(incidencia) {
        return this._http.put<any>(environment.apiEndpoint + '/Incidencia/', incidencia);
    }

    public deleteIncidencia(incidenciaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Incidencia/?incidenciaId=' + incidenciaId);
    }

    public getRepIncidenciasPdf(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepIncidencias', filters);
    }

    public getRepIncidenciasCsv(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvIncidencias', filters);
    }


    // GRUPOS DE ETIQUETA
    public getGruposEtiqueta(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/GrupoEtiqueta/GetAllConFiltro', filters);
    }

    public updateGruposEtiquetaEtiquetadorPaisDenominacion(grupoEtiqueta) {
        return this._http.put<any>(environment.apiEndpoint +
            '/GrupoEtiqueta/UpdateGrupoEtiquetaEtiquetadorPaisDenominacion', grupoEtiqueta);
    }

    public deleteGruposEtiquetaEtiquetadorPaisDenominacion(grupoEtiqueta) {
        return this._http.delete<any>(environment.apiEndpoint + '/GrupoEtiqueta/DeleteGrupoEtiquetaEtiquetadorPaisDenominacion/?grupoEtiquetaId='
            + grupoEtiqueta.grupoEtiquetaId + '&etiquetadorId=' + grupoEtiqueta.etiquetadorId +
                '&paisId=' + grupoEtiqueta.paisId + '&denominacionId=' + grupoEtiqueta.denominacionId);
    }

    public updateGruposEtiquetaEtiquetadorMarcaPaisDenominacion(grupoEtiqueta) {
        return this._http.put<any>(environment.apiEndpoint +
            '/GrupoEtiqueta/UpdateGrupoEtiquetaEtiquetadorMarcaPaisDenominacion', grupoEtiqueta);
    }

    public deleteGruposEtiquetaEtiquetadorMarcaPaisDenominacion(grupoEtiqueta) {
        return this._http.delete<any>(environment.apiEndpoint + '/GrupoEtiqueta/DeleteGrupoEtiquetaEtiquetadorMarcaPaisDenominacion/?grupoEtiquetaId='
            + grupoEtiqueta.grupoEtiquetaId + '&etiquetadorId=' + grupoEtiqueta.etiquetadorId + '&marcaId=' + grupoEtiqueta.marcaId +
                '&paisId=' + grupoEtiqueta.paisId + '&denominacionId=' + grupoEtiqueta.denominacionId);
    }

    // REPORTE - CULTIVOS
    public getReportCultivos(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Consumo/GetReportCultivosTotalesResumen', filters);
    }

    public getCultivosPdfOrExcel(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepCultivoTotales', filters);
    }

    // CSV REPORTES
    public getCultivosCsvReport(filters) {
        //TO-DO: cambiar endpoint cuando este disponible
      return this._http.post<any>(environment.apiEndpoint + '/Report/ExportCsvCultivoTotales', filters);
    }

    // TRAZABILIDAD ETIQUETA
    public getTrazabilidadEtiqueta(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/TrazabilidadEtiqueta/GetBySNCAnonimo', filters);
    }

    // ETIQUETADORES - REETIQUETADORES
    public getReetiquetadores(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/EtiquetadorReetiquetador/GetAllConFiltro', filters);
    }

    public asociarEtqRtq(etiquetadorReetiquetador) {
        return this._http.post<any>(environment.apiEndpoint + '/EtiquetadorReetiquetador', etiquetadorReetiquetador);
    }

    public deleteEtqRtq(etiquetadorId, reetiquetadorId) {
        return this._http.delete<any>(environment.apiEndpoint + '/EtiquetadorReetiquetador/?etiquetadorId=' + etiquetadorId + '&reetiquetadorId=' + reetiquetadorId);
    }

    // AYUDA
    public getDocHelp(nombreArchivo: string) {
      return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }
}
